import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// import Head from '../header';
// import Foot from '../footer';
import Sidebar from '../../pages/home/Sidebar';
import Footer from '../../pages/home/Footer';
import Navbar from '../../pages/home/Navbar';
import { scrollToTop } from '../../lib/utils';

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isNavbarShrunk, setIsNavbarShrunk] = useState(false);

  // Gestion du scroll pour la navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsNavbarShrunk(true);
      } else {
        setIsNavbarShrunk(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    scrollToTop()
  }, [])


  // Ajoutez ces fonctions dans votre composant App
  const handleSidebarMouseEnter = () => {
    document.body.style.overflow = 'hidden';
  };

  const handleSidebarMouseLeave = () => {
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar isSidebarOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        isShrunk={isNavbarShrunk} />

      <div className="flex flex-1">
        <Sidebar
          toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          isOpen={isSidebarOpen}
          onMouseEnter={handleSidebarMouseEnter}
          onMouseLeave={handleSidebarMouseLeave} />

        <main className={`flex-1 transition-all duration-300  ${isSidebarOpen ? ' ml-60 lg:ml-0' : ' ml-0'}`} >
          <div className=' overflow-x-hidden mt-[100px] md:mt-[98px]' >
            <Outlet />
          </div>
          <Footer />
        </main>
      </div>

    </div>
  );
};

export default MainLayout;
